import {h} from 'preact';
import Filter from './Filter';
import RootList from './RootList';
import RootVisual from './RootVisual';
import {SubscribedComponent} from './Store/index';
import State from './Store/State';
import VisualFilter from './VisualFilter';


/**
 * Component Properties.
 */
interface RootProps
{
	[key: string]: void;
}

/**
 * Component State.
 */
interface RootState
{
	/** Визуальный режим? */
	visualMode: boolean;
}

/**
 * Application root
 */
class Root extends SubscribedComponent<State, RootProps, RootState>
{
	/**
	 * Класс, добавляемый на body при инициализации компонента.
	 */
	private static readonly CLASS_BODY_READY = 'ready';
	/**
	 * Класс, добавляемый на body при визуальном режиме.
	 */
	private static readonly CLASS_BODY_VISUAL = 'visual';
	
	/**
	 * Rendered component mounted to the DOM.
	 */
	public componentDidMount(): void
	{
		document.body.classList.add( Root.CLASS_BODY_READY );
	}
	
	/**
	 * Render component.
	 */
	public render( _props: RootProps, {visualMode}: RootState ): JSX.Element
	{
		if ( !visualMode )
		{
			setTimeout( () => {
				const popup = document.querySelector( 'div.popup' );

				if ( !popup )
				{
					return;
				}

				popup.classList.remove( 'hide' );
			}, 3000 );
		}
		
		return (
			<main>
				{
					visualMode
					? [
						<VisualFilter />,
						<RootVisual />,
					]
					: [
						<Filter />,
						<RootList />,
					]
				}
			</main>
		);
	}
	
	/**
	 * Handle Store changes.
	 */
	protected storeStateChanged(
		{common: {visualMode}}: State,
	): void
	{
		if ( visualMode === this.state.visualMode )
		{
			return;
		}
		
		if ( visualMode !== this.state.visualMode )
		{
			if ( visualMode )
			{
				document.body.classList.add( Root.CLASS_BODY_VISUAL );
			}
			else
			{
				document.body.classList.remove( Root.CLASS_BODY_VISUAL );
			}
		}
		
		this.setState( {visualMode} );
	}
}

/**
 * Module.
 */
export {
	Root as default,
	RootProps,
	RootState,
};



// WEBPACK FOOTER //
// ./app/Routes/Choose/App/Root.tsx